const o = {
  image: ["image/*"],
  csv: ["text/csv", "application/vnd.ms-excel", "application/csv", ".csv"]
}, c = (e, s) => s.some((t) => {
  if (t.includes("*")) {
    const n = t.replace("*", ".*");
    return new RegExp(`^${n}$`).test(e);
  } else
    return e.toLowerCase() === t.toLowerCase();
}), r = (e) => e.join(", ");
export {
  o as fileInputAcceptTypes,
  r as formatAcceptTypeForInput,
  c as isAcceptTypeValid
};
